/* import __COLOCATED_TEMPLATE__ from './resistor-tolerance.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();